import axios from 'axios'

export const loadEventsList = (start = 0, limit = 5) => {
    return (dispatch, store) => {
        dispatch({
            type: 'EVENTS_LIST_STATUS',
            payload: 'loading'
        })
        axios.get('events/list_events/'+start+'/'+limit)
        .then(response => {
            dispatch({
                type: 'EVENTS_LIST_DATA',
                payload: response.result
            })
            dispatch({
                type: 'EVENTS_LIST_STATUS',
                payload: 'done'
            })
        })
    }

}

export const loadEventToken = (token, forceLoad = false) => {
    return (dispatch, store) => {

        dispatch({
            type: 'EVENT_STATUS',
            payload: {
                token,
                status: 'loading'
            }
        })

        
        // if(!forceLoad && store().events.event[token])
        // return

        
        return axios.get('events/token/'+token)
        .then(response => {
            if(response.errors) {
                if(response.errors[0].type === 'not_found') {
                    dispatch({
                        type: 'EVENT_STATUS',
                        payload: {
                            token,
                            status: 'not_found'
                        }
                    })
                }
            } else {

                dispatch({
                    type: 'EVENT_LOADED',
                    payload: {
                        token,
                        data: response
                    }
                })
            }

            return response
        })
    }
}


// WEBPACK FOOTER //
// ./src/modules/actions/Events.js